import { render, staticRenderFns } from "./CopyBtn.vue?vue&type=template&id=01306bd1&scoped=true&"
import script from "./CopyBtn.vue?vue&type=script&lang=ts&"
export * from "./CopyBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CopyBtn.vue?vue&type=style&index=0&id=01306bd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01306bd1",
  null
  
)

export default component.exports